import { render } from "./Account.vue?vue&type=template&id=71e0c340&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=71e0c340&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71e0c340"

export default script